"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLATFORM_OPTION = exports.PLATFORM_NAME_MAP = exports.PLATFORM_ICON_MAP = void 0;
require("core-js/modules/es6.function.name");
// 渠道平台编码与展示名（与后端 UnionEnum 一致；商品页、订单页共用）
var PLATFORM_OPTION = exports.PLATFORM_OPTION = [{
  code: 'TB',
  name: '淘宝',
  icon: require('@/assets/platformIcon/tb.png')
}, {
  code: 'JD',
  name: '京东',
  icon: require('@/assets/platformIcon/jd.png')
}, {
  code: 'PDD',
  name: '拼多多',
  icon: require('@/assets/platformIcon/pdd.png')
}, {
  code: 'WPH',
  name: '唯品会',
  icon: require('@/assets/platformIcon/wph.png')
}, {
  code: 'DY',
  name: '抖音',
  icon: require('@/assets/platformIcon/dy.png')
}];

// 渠道编码 -> 展示名，供商品/订单列表按编码回显中文
var PLATFORM_NAME_MAP = exports.PLATFORM_NAME_MAP = PLATFORM_OPTION.reduce(function (result, item) {
  result[item.code] = item.name;
  return result;
}, {});

// 渠道编码 -> 图标，供列表与详情按编码展示平台角标
var PLATFORM_ICON_MAP = exports.PLATFORM_ICON_MAP = PLATFORM_OPTION.reduce(function (result, item) {
  result[item.code] = item.icon;
  return result;
}, {});